import { ACHIEVEMENT_BADGE_SHAPES as SHAPES } from '../achievementBadgeShapes';
import React from 'react';
import PropTypes from 'prop-types';
import AchievementBadge from './AchievementBadge';

/* eslint-disable max-len */
const hexagon = ({ fill, stroke }) =>
	<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M31 2.88675L52.9808 15.5774C53.5996 15.9346 53.9808 16.5949 53.9808 17.3094V42.6906C53.9808 43.4051 53.5996 44.0654 52.9808 44.4226L31 57.1133C30.3812 57.4705 29.6188 57.4705 29 57.1132L7.01924 44.4226C6.40043 44.0654 6.01924 43.4051 6.01924 42.6906V17.3094C6.01924 16.5949 6.40043 15.9346 7.01924 15.5774L29 2.88675C29.6188 2.52949 30.3812 2.52949 31 2.88675Z"
			fill={fill} stroke={stroke} strokeWidth="4"
		/>
	</svg>;

const square = ({ fill, stroke }) =>
	<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M52 6H8C6.89543 6 6 6.89543 6 8V52C6 53.1046 6.89543 54 8 54H52C53.1046 54 54 53.1046 54 52V8C54 6.89543 53.1046 6 52 6Z"
			fill={fill} stroke={stroke} strokeWidth="4"
		/>
	</svg>;

const shield = ({ fill, stroke }) =>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
		<path
			d="M13.9746 3.03809H14.0195C15.1726 3.32596 20.0856 4.44022 24.417 3.51465L24.834 3.41895C24.8777 3.40814 24.9301 3.41763 24.9688 3.44531C24.9815 3.45453 24.9877 3.46313 24.9902 3.4668C24.9044 10.0987 24.1946 14.5096 22.5254 17.7236C20.8846 20.8826 18.2504 23.008 13.998 24.9082C9.60449 22.9712 6.9761 20.8752 5.37109 17.7549C3.83712 14.7724 3.17322 10.7377 3.03027 4.74023L3.00879 3.51367C3.01124 3.50966 3.0198 3.49802 3.03906 3.48438C3.07514 3.45888 3.11977 3.44569 3.16113 3.44629L3.20117 3.45215C5.35867 3.99013 7.76364 3.94854 9.73633 3.75195C11.2261 3.60348 12.5124 3.36142 13.3271 3.18555L13.9746 3.03809Z"
			fill={fill}
			stroke={stroke}
			strokeWidth="2"
		/>
	</svg>;

const circle = ({ fill, stroke }) =>
	<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="6" y="6" width="48" height="48" rx="24" fill={fill} stroke={stroke} strokeWidth="4"/>
	</svg>;

function badgeRenderer({ shape }) {
	switch (shape) {
	case SHAPES.square:
		return square;
	case SHAPES.circle:
		return circle;
	case SHAPES.hexagon:
		return hexagon;
	case SHAPES.shield:
		return shield;
	default:
		return hexagon;
	}
}

export default function AchievementBadgeBackground({ shape, fill, stroke }) {
	return badgeRenderer({ shape })({ fill, stroke });
}

AchievementBadge.propTypes = {
	shape: PropTypes.oneOf(Object.values(SHAPES)),
	fill: PropTypes.string.isRequired,
	stroke: PropTypes.string.isRequired,
};
